import React, { useState } from 'react';
import './App.css';

function Login({
  esModoLogin,
  setEsModoLogin,
  formData,
  handleChange,
  manejarSubmit,
  carnetAnverso,
  setCarnetAnverso,
  carnetReverso,
  setCarnetReverso,
  aceptoPoliticas,
  setAceptoPoliticas,
  terminosLeidos,
  abrirTerminosYHabilitar,
  setMostrarAuthForm,
  mostrarModalTerminos,
  setMostrarModalTerminos,
  cerrarYAceptarTerminos
}) {
  const [mostrarModalRecuperar, setMostrarModalRecuperar] = useState(false);
  const [correoRecuperacion, setCorreoRecuperacion] = useState('');

  const manejarRecuperacion = async (e) => {
    e.preventDefault();

    try {
        const formData = new FormData();
        formData.append('email', correoRecuperacion);

        const response = await fetch(
            'https://micontenidohot.com/olvide_password.php',
            {
                method: 'POST',
                body: formData
            }
        );

        const data = await response.json();

        if (data.success) {
            alert('Se envió un enlace de recuperación a tu correo.');
            setMostrarModalRecuperar(false);
            setCorreoRecuperacion('');
        } else {
            alert(data.mensaje);
        }

    } catch (error) {
        console.error(error);
        alert('Error al enviar la solicitud');
    }
  };

  return (
    <div className="modal-overlay" style={{ backdropFilter: 'blur(20px)', background: 'rgba(0, 0, 0, 0.85)', overflowY: 'auto', padding: '30px 15px' }}>
      <div className="modal-content" style={{ maxWidth: '420px', width: '100%', margin: 'auto', padding: '30px', borderRadius: '24px', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}>
        
        {/* Cabecera / Logo */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <img src="/logo.png" alt="Logo Passion" style={{ width: '120px', height: '120px', objectFit: 'contain' }} />
            <h1 style={{ fontSize: '1.45rem', fontWeight: '800', color: '#0f172a', margin: 0 }}>
              <span style={{ color: '#ff2c55' }}></span>
            </h1>
          </div>
          <p style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: '500' }}>
            {esModoLogin ? 'Ingresa tus datos para acceder a tu cuenta.' : 'Crea una cuenta para publicar tus anuncios.'}
          </p>
        </div>

        {/* Formulario */}
        <form onSubmit={manejarSubmit}>
          {!esModoLogin && (
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '700', color: '#334155', marginBottom: '6px' }}>
                Nombre Completo o Nombre Artístico
              </label>
              <input 
                type="text" 
                name="nombre" 
                value={formData.nombre} 
                onChange={handleChange} 
                required 
                placeholder="Ej. Camila Sol"
                style={{ width: '100%', padding: '12px 14px', borderRadius: '12px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none', background: '#f8fafc' }}
              />
            </div>
          )}

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '700', color: '#334155', marginBottom: '6px' }}>
              Correo Electrónico
            </label>
            <input 
              type="email" 
              name="email" 
              value={formData.email} 
              onChange={handleChange} 
              required 
              placeholder="correo@ejemplo.com"
              style={{ width: '100%', padding: '12px 14px', borderRadius: '12px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none', background: '#f8fafc' }}
            />
          </div>

          <div style={{ marginBottom: esModoLogin ? '8px' : '18px' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '700', color: '#334155', marginBottom: '6px' }}>
              Contraseña
            </label>
            <input 
              type="password" 
              name="password" 
              value={formData.password} 
              onChange={handleChange} 
              required 
              placeholder="••••••••"
              style={{ width: '100%', padding: '12px 14px', borderRadius: '12px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none', background: '#f8fafc' }}
            />
          </div>

          {/* Enlace de Restablecer Contraseña (Solo en Modo Login) */}
          {esModoLogin && (
            <div style={{ textAlign: 'right', marginBottom: '20px' }}>
              <span 
                onClick={() => setMostrarModalRecuperar(true)}
                style={{ fontSize: '0.78rem', color: '#ff2c55', fontWeight: '700', cursor: 'pointer', textDecoration: 'underline' }}
              >
                ¿Olvidaste tu contraseña?
              </span>
            </div>
          )}

          {/* Campos exclusivos de Registro (Verificación de identidad con Carnet) */}
          {!esModoLogin && (
            <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '14px', border: '1px solid #e2e8f0', marginBottom: '18px' }}>
              <h4 style={{ fontSize: '0.82rem', color: '#0f172a', fontWeight: '800', marginBottom: '6px' }}>
                Verificación de Identidad (Obligatorio)
              </h4>
              <p style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '12px', lineHeight: '1.4' }}>
                Sube fotos claras de tu documento de identidad (Carnet / Cédula) por ambos lados para verificar que eres mayor de edad. Esto no será público.
              </p>

              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#475569', marginBottom: '4px' }}>
                  Foto Carnet (Anverso / Frontal):
                </label>
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={(e) => setCarnetAnverso(e.target.files[0])} 
                  required
                  style={{ fontSize: '0.8rem', width: '100%' }}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '700', color: '#475569', marginBottom: '4px' }}>
                  Foto Carnet (Reverso / Posterior):
                </label>
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={(e) => setCarnetReverso(e.target.files[0])} 
                  required
                  style={{ fontSize: '0.8rem', width: '100%' }}
                />
              </div>
            </div>
          )}

          {/* Términos y Condiciones (Solo en registro) */}
          {!esModoLogin && (
            <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
              <input 
                type="checkbox" 
                id="terminos" 
                checked={aceptoPoliticas} 
                disabled={!terminosLeidos}
                onChange={(e) => setAceptoPoliticas(e.target.checked)}
                style={{ marginTop: '3px', cursor: terminosLeidos ? 'pointer' : 'not-allowed', width: '16px', height: '16px' }}
              />
              <label htmlFor="terminos" style={{ fontSize: '0.8rem', color: '#475569', lineHeight: '1.4' }}>
                He leído y acepto los{' '}
                <span 
                  onClick={abrirTerminosYHabilitar}
                  style={{ color: '#ff2c55', textDecoration: 'underline', cursor: 'pointer', fontWeight: '700' }}
                >
                  términos, condiciones y políticas de privacidad
                </span>.
              </label>
            </div>
          )}

          {/* Botón Principal */}
          <button 
            type="submit" 
            className="btn-create-account" 
            style={{ width: '100%', padding: '14px', fontWeight: '700', fontSize: '0.95rem', marginBottom: '16px', borderRadius: '14px' }}
          >
            {esModoLogin ? 'Iniciar Sesión' : 'Crear Cuenta'}
          </button>
        </form>

        {/* Alternar entre Login y Registro */}
        <div style={{ textAlign: 'center', fontSize: '0.85rem', color: '#64748b', marginBottom: '20px' }}>
          {esModoLogin ? (
            <>
              ¿No tienes cuenta?{' '}
              <span 
                onClick={() => setEsModoLogin(false)} 
                style={{ color: '#ff2c55', fontWeight: '700', cursor: 'pointer', textDecoration: 'underline' }}
              >
                Regístrate
              </span>
            </>
          ) : (
            <>
              ¿Ya tienes una cuenta?{' '}
              <span 
                onClick={() => setEsModoLogin(true)} 
                style={{ color: '#ff2c55', fontWeight: '700', cursor: 'pointer', textDecoration: 'underline' }}
              >
                Inicia Sesión
              </span>
            </>
          )}
        </div>

        {/* Botón Volver Atrás */}
        <div style={{ textAlign: 'center', borderTop: '1px solid #f1f5f9', paddingTop: '16px' }}>
          <button 
            onClick={() => setMostrarAuthForm(false)} 
            style={{ background: 'none', border: 'none', color: '#64748b', fontSize: '0.85rem', cursor: 'pointer', fontWeight: '700', padding: '6px 12px', borderRadius: '8px', transition: 'background 0.2s' }}
            onMouseEnter={(e) => e.target.style.background = '#f1f5f9'}
            onMouseLeave={(e) => e.target.style.background = 'transparent'}
          >
            ← Volver Atrás
          </button>
        </div>

        {/* MODAL INTERNO DE TÉRMINOS Y CONDICIONES */}
        {mostrarModalTerminos && (
          <div className="modal-overlay" style={{ zIndex: 1000, background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(5px)' }}>
            <div className="modal-content" style={{ maxWidth: '450px', width: '90%', background: '#fff', padding: '24px', borderRadius: '24px', maxHeight: '80vh', overflowY: 'auto' }}>
              <h3 style={{ color: '#0f172a', fontSize: '1.2rem', fontWeight: '800', marginBottom: '14px' }}>
                Términos, Condiciones y Políticas
              </h3>
              
              <div style={{ fontSize: '0.82rem', color: '#475569', lineHeight: '1.6', marginBottom: '20px', textAlign: 'left' }}>
                <p style={{ marginBottom: '10px' }}>
                  Bienvenido a <strong>micontenidohot.com</strong>. Al registrarte y utilizar nuestros servicios, aceptas cumplir con las siguientes normativas de uso y políticas de privacidad:
                </p>
                <p style={{ marginBottom: '10px' }}>
                  1. <strong>Mayoría de edad:</strong> Este sitio web es exclusivo para adultos mayores de 18 años. Está estrictamente prohibido el acceso a menores de edad.
                </p>
                <p style={{ marginBottom: '10px' }}>
                  2. <strong>Veracidad de la información:</strong> Las fotografías y documentos de identidad enviados son estrictamente para validar la autenticidad del perfil y proteger a la comunidad de perfiles falsos o estafas.
                </p>
                <p style={{ marginBottom: '10px' }}>
                  3. <strong>Responsabilidad del contenido:</strong> Los usuarios son plenamente responsables de la información y anuncios que decidan publicar dentro de la plataforma.
                </p>
              </div>

              <button 
                onClick={cerrarYAceptarTerminos}
                className="btn-create-account"
                style={{ width: '100%', padding: '13px', borderRadius: '14px' }}
              >
                Entendido y Aceptar
              </button>
            </div>
          </div>
        )}

        {/* MODAL PARA RECUPERAR CONTRASEÑA */}
        {mostrarModalRecuperar && (
          <div className="modal-overlay" style={{ zIndex: 1000, background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(5px)' }}>
            <div className="modal-content" style={{ maxWidth: '380px', width: '90%', background: '#fff', padding: '24px', borderRadius: '24px', textAlign: 'center' }}>
              <div style={{ fontSize: '2.2rem', marginBottom: '10px' }}>🔒</div>
              <h3 style={{ color: '#0f172a', fontSize: '1.15rem', fontWeight: '800', marginBottom: '8px' }}>
                Restablecer Contraseña
              </h3>
              <p style={{ fontSize: '0.82rem', color: '#64748b', marginBottom: '16px', lineHeight: '1.4' }}>
                Ingresa tu correo electrónico registrado y te enviaremos los pasos para recuperar el acceso a tu cuenta.
              </p>

              <form onSubmit={manejarRecuperacion}>
                <input 
                  type="email" 
                  value={correoRecuperacion} 
                  onChange={(e) => setCorreoRecuperacion(e.target.value)}
                  required 
                  placeholder="tucorreo@ejemplo.com"
                  style={{ width: '100%', padding: '12px 14px', borderRadius: '12px', border: '1px solid #cbd5e1', fontSize: '0.9rem', marginBottom: '14px', outline: 'none', background: '#f8fafc' }}
                />

                <div style={{ display: 'flex', gap: '10px' }}>
                  <button 
                    type="button" 
                    onClick={() => setMostrarModalRecuperar(false)}
                    style={{ flex: 1, padding: '12px', background: '#f1f5f9', border: 'none', borderRadius: '12px', color: '#475569', fontWeight: '700', cursor: 'pointer' }}
                  >
                    Cancelar
                  </button>
                  <button 
                    type="submit"
                    className="btn-create-account"
                    style={{ flex: 1, padding: '12px', borderRadius: '12px' }}
                  >
                    Enviar
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default Login;